import CreateIcon from '@mui/icons-material/Create';
import { IconButton, Paper, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { GridSortModel } from '@mui/x-data-grid';
import { useCallback, useMemo, useRef } from 'react';
import { Link as NavLink } from 'react-router-dom';
import { useRecoilValueLoadable } from 'recoil';
import { v4 as uuidv4 } from 'uuid';

import { useBusinessPermissions } from '../../common/helperFunctions/useBusinessPermissions';
import { Role } from '../../recoil/atoms/user';
import { dispositionSelector } from '../../recoil/selectors/dispositions';
import { permissionsSelector } from '../../recoil/selectors/permissionsSelector';
import { TeamDropdown } from '../components/dropdowns/TeamDropdown';
import dataTableScss from '../modules/Manage/pages/queues-table/data-table.module.css';
import {
  DataTable,
  IColDef,
} from '../modules/Manage/pages/queues-table/DataTable';
import { EnhancedTableToolbar } from '../modules/Manage/pages/queues-table/EnhancedTableToolbar';

const useStyles = makeStyles({
  toolbar: {
    '& hr': {
      marginLeft: '1vw',
    },
  },
});

export function Dispositions(props) {
  const classes = useStyles();
  const dispositions = useRecoilValueLoadable(dispositionSelector);
  const rowsCached = useRef<any[]>([]);
  const permissionsLoadable = useRecoilValueLoadable(permissionsSelector);
  const { role } = permissionsLoadable.contents;
  const isUser = role === Role.USER;
  rowsCached.current = useMemo(
    () =>
      dispositions.state === 'hasValue'
        ? dispositions.contents?.allStats?.map((o) => ({
            ...o,
            id: uuidv4(),
          }))
        : [],
    [dispositions]
  );
  const ToolbarComponent = useCallback(
    (props) => (
      <EnhancedTableToolbar
        {...props}
        dataType="Dispositions"
        className={classes.toolbar}
        leftComponent={<TeamDropdown />}
      />
    ),
    [classes]
  );
  const sortModel: GridSortModel = [
    {
      field: 'not disposed',
      sort: 'desc',
    },
  ];
  function actionsFormatter(params) {
    // console.log(params, 'oarams in action formatter');
    return isUser ? (
      params.value
    ) : (
      <Tooltip title="View Agent">
        <NavLink
          // onClick={() => viewAction(params.row)}
          to={`/manage/agents/${params.row.userid}`}
        >
          <IconButton name="view" size="large">
            <CreateIcon color="primary" />
          </IconButton>
        </NavLink>
      </Tooltip>
    );
  }
  const readOnly = useBusinessPermissions().accountReadOnly;

  const columns = useMemo(() => {
    const cols: IColDef[] = [];
    if (dispositions.state === 'hasValue') {
      cols.push({
        field: 'email',
        headerName: 'Email',
        headerClassName: dataTableScss.fullWidth,
        cellClassName: dataTableScss.fullWidth,
        renderCell: (params) =>
          params.value === 'N/A' || isUser ? (
            params.value
          ) : (
            <NavLink to={`/manage/agents/${params.row.userid}/edit`}>
              {params.value}
            </NavLink>
          ),
      });
      dispositions?.contents?.columns?.forEach((el, i) => {
        const obj = {} as any;
        obj.field = el;
        obj.headerName = el === 'not disposed' ? 'No Call Outcome' : el;
        obj.headerClassName = dataTableScss.fullWidth;
        obj.cellClassName = dataTableScss.fullWidth;
        cols.push(obj);
      });
      cols.push({
        field: 'actions',
        headerName: 'View Action',
        hide: readOnly,
        enableSorting: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: actionsFormatter,
      });
      return cols;
    } else return [];
  }, [dispositions]);

  return (
    <Paper elevation={0}>
      <DataTable
        rows={rowsCached?.current ?? []}
        columns={columns}
        sortModel={sortModel}
        loading={dispositions.state === 'loading'}
        ToolbarComponent={ToolbarComponent}
      />
    </Paper>
  );
}
